import { gql } from "gql";

export const GET_MY_PERSON_IS_MANAGER = gql(/* GraphQL */ `
  query GetMyPersonIsManager {
    getMyPerson {
      id
      management {
        isManager
      }
    }
  }
`);
